import { useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'
import moment from 'moment'
import DependantForm from '../../components/DependantForm'
import Onboarding from './Onboarding'
import OnboardingComplete from './Partials/OnboardingComplete'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'sonner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Dependants = () => {
  const { setShowLoader, can, createInfo, auth, admin } = useAuth()
  const axios = useAxiosPrivate()

  const [dependants, setDependants] = useState(null)

  const [showCompletedOnboardingModal, setShowCompleteOnboardingModal] =
    useState(false)
  const [showOnboardingModal, setShowOnboardingModal] = useState(false)

  const [editingDependant, setEditingDependant] = useState(null)
  const [deleteDependant, setDeleteDependant] = useState(null)

  const [showAddDependant, setShowAddDependant] = useState(false)

  useEffect(() => {
    if (!auth?.user) return
    setDependants(auth.user.dependants || [])
  }, [auth?.user])

  const handleEditDependant = (dependant) => {
    setEditingDependant(dependant)
  }

  const handleDeleteDependant = async (dependant) => {
    try {
      await axios.delete(`/users/${auth.user.id}/dependants/${dependant.id}`)
      toast.success('Dependant deleted successfully')
      setDeleteDependant(null)
      setDependants((prev) => prev.filter((d) => d.id !== dependant.id))
    } catch (err) {
      console.error(err)
      toast.error('Failed to delete dependant')
    }
  }

  const calculateAge = (birthDate) => {
    return moment().diff(moment(birthDate), 'years')
  }

  return (
    <section className="pb-16">
      {/* <MainTitle title="Account" /> */}
      <div className="flex-1 xl:overflow-y-auto pb-10 max-w-4xl mx-auto">
        {/* Dependants Section */}
        <div className="w-full gap-y-6 py-8 sm:gap-x-6">
          {showCompletedOnboardingModal && (
            <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
              <div className="bg-white rounded-2xl p-8 shadow-2xl w-full max-w-xl border border-[#e0d0f7] relative animate-fade-in">
                <div className="flex flex-col items-center py-8">
                  <OnboardingComplete dependant={true} />
                  <button
                    onClick={() => {
                      setShowCompleteOnboardingModal(false)
                      window.location.reload()
                    }}
                    className="w-full px-6 py-3 mt-4 bg-[#866393] text-white rounded-lg font-semibold shadow hover:bg-[#6b4c7c] transition"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          )}
          {deleteDependant && (
            <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
              <div className="bg-white rounded-2xl p-8 shadow-2xl w-full max-w-md border border-gray-200 relative animate-fade-in">
                <h3 className="text-xl font-semibold text-slate-800 text-center">
                  Confirm Deletion
                </h3>
                <p className="text-center text-slate-600 mt-2">
                  Are you sure you want to delete the dependant{' '}
                  <strong>{deleteDependant.name}</strong>? This action cannot be
                  undone.
                </p>
                <div className="flex justify-center gap-4 mt-6">
                  <button
                    onClick={() => setDeleteDependant(null)}
                    className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleDeleteDependant(deleteDependant)}
                    className="px-6 py-2 bg-red-600 text-white rounded-lg font-semibold shadow hover:bg-red-700 transition"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
          {showOnboardingModal ? (
            <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
              <div className="bg-white rounded-lg p-6 shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">
                {/* <h2 className="text-2xl font-bold mb-4">Complete Your Profile</h2> */}
                <Onboarding
                  setShowOnboardingCompletedModal={
                    setShowCompleteOnboardingModal
                  }
                  setShowOnboardingModal={setShowOnboardingModal}
                  dependant={true}
                />
              </div>
            </div>
          ) : editingDependant ? (
            <DependantForm
              setShowForm={() => setEditingDependant(null)}
              mode="edit"
              initialData={editingDependant.attributes}
              dependant={editingDependant}
              dependantId={editingDependant.id}
            />
          ) : (
            <div className="sm:col-span-6">
              {/* Header with button */}
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-2xl font-semibold leading-7 text-slate-900">
                    Dependants
                  </h2>
                  <p className="mt-1 text-sm text-slate-600">
                    Manage information for your dependants.
                  </p>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={setShowOnboardingModal.bind(this, true)}
                    className="bg-hub-primary-light border-2 border-hub-primary-light text-[#41264B] font-medium px-5 py-1.5 rounded-md hover:bg-white transition"
                  >
                    Add Dependant
                  </button>
                </div>
              </div>

              {/* Dependants list */}
              {dependants && dependants.length > 0 ? (
                <div className="mt-6 space-y-8">
                  {dependants.map((dependant) => (
                    <div
                      key={dependant.id}
                      className="bg-white p-4 border border-gray-200 rounded-lg flex justify-between items-center"
                    >
                      <div>
                        <h3 className="text-lg font-medium text-slate-900">
                          {dependant?.name} (Age:{' '}
                          {calculateAge(dependant?.date_of_birth) || 'N/A'})
                        </h3>
                        <p className="text-sm text-gray-600">
                          DOB:{' '}
                          {moment(dependant?.date_of_birth).format(
                            'DD/MM/YYYY'
                          ) || 'N/A'}
                        </p>
                        <p className="text-sm text-gray-600">
                          Gender: {dependant?.user_info?.gender || 'N/A'}
                        </p>
                      </div>

                      {/* Icon Buttons */}
                     <div className="flex items-center gap-2">
                     {dependant.type_id === 4 && ( <button
                          onClick={() => handleEditDependant(dependant)}
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-blue-100 text-blue-500 hover:text-blue-700"
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                      
                      )}
                        <button
                          onClick={() => setDeleteDependant(dependant)}
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-100 text-red-500 hover:text-red-700"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="mt-4 text-sm text-slate-600">
                  No dependants added yet.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Dependants
